
$(document).on("turbolinks:load", function () {
  var body_id = document.body.id;
  if(body_id != "refunded_orders-new")
    Dropzone.autoDiscover = false;
  $(document).on("click", "#purchase-link-btn", function (e) {
    e.preventDefault();
    base_url = $("#sh-base-url").data("url");
    loc_id = $("#customer_purchase_notification_location_id").val();
    st_id = $("#customer_purchase_notification_stop_id").val();
    if (st_id != "") {
      $("#purchase_link").removeClass("hide").text("");
      $("#purchase_link").append(
        '<a target="_blank" href="' +
          base_url +
          "/pages/preorder?location_id=" +
          loc_id +
          "&stop_id=" +
          st_id +
          '">' +
          base_url +
          "/pages/preorder?location_id=" +
          loc_id +
          "&stop_id=" +
          st_id +
          "</a>"
      );
    } else {
      $("#purchase_link").removeClass("hide").text("");
      $("#purchase_link").show().text("Please select a location and a stop!");
    }
  });
  window.mini = true;
  window.x = window.matchMedia("(min-width: 992px)");
  if (Cookies.get("mini_menu") === undefined) {
    Cookies.set("mini_menu", "true");
  }
  var mini_menu = Cookies.get("mini_menu");
  initMenu();

  $(document).on("mouseenter", "#aside", function (event) {
    Cookies.set("mini_menu", "false");
    if (x.matches) {
      setMaxi();
    }
  });

  $(document).on("mouseleave", "#aside", function (event) {
    Cookies.set("mini_menu", "true");
    if (x.matches) {
      setMini();
    }
  });

  $(document).on("click", ".remove_fields", function (event) {
    var link = event.target;
    // Stop the function from executing if a link or event were not passed into the function.
    if (!link || !event) return;
    // Prevent the browser from following the URL.
    event.preventDefault();
    // Find the parent wrapper for the set of nested fields.
    let fieldParent = link.parentElement.parentElement;
    // If there is a parent wrapper, find the hidden delete field.
    let deleteField = fieldParent
      ? fieldParent.querySelector(".destroy_location_attachment")
      : null;
    // If there is a delete field, update the value to `1` and hide the corresponding nested fields.
    if (deleteField) {
      deleteField.value = 1;
      fieldParent.style.display = "none";
    }
  });

  function initMenu() {
    if (mini_menu == "false" && x.matches) {
      setMaxi();
    } else if (mini_menu == "true" && x.matches) {
      setMini();
    }
  }

  function setMini() {
    if (document.getElementById("aside") !== null) {
      document.getElementById("aside").style.width = "60px";
      document.getElementById("page-content").style.marginLeft = "60px";
      document.getElementById("image-logo").classList.add("invisible");
      document.querySelector("#user-button .user-details").style.display =
        "none";
      document
        .querySelector("#aside .main-side-nav ul")
        .classList.remove("active");

      var slides = document.getElementsByClassName("is-accordion-submenu");
      for (var i = 0; i < slides.length; i++) {
        slides[i].style.display = "none";
      }
    }
  }

  function setMaxi() {
    if (document.getElementById("aside") !== null) {
      document.getElementById("aside").style.width = "250px";
      document.getElementById("page-content").style.marginLeft = "250px";
      document.getElementById("image-logo").classList.remove("invisible");
      document.querySelector("#user-button .user-details").style.display =
        "block";
      document
        .querySelector("#aside .main-side-nav ul")
        .classList.add("active");
      var slides = document.getElementsByClassName("is-accordion-submenu");
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].parentElement.getAttribute("aria-expanded") == "true") {
          slides[i].style.display = "block";
        }
      }
    }
  }

  $(".submenu").each(function () {
    if ($(this).find(".is-active").length > 0) {
      $(this).addClass("is-active");
    }
  });

  $(".preorder_check").on("click", function () {
    var siblings = $(this).closest("tr").find(".sibling");
    $.each(siblings, function () {
      if ($(this).hasClass("hide")) {
        $(this).removeClass("hide");
      } else {
        $(this).addClass("hide");
      }
    });
  });

  $("[data-submit-form]").click(function (e) {
    e.preventDefault();
    $($(this).data("submit-form")).submit();
  });

  $(".product-categories").selectize({
    create: false,
    multiple: true,
  });

  $(".save_product").on("click", function () {
    let container = $(this).closest("tr");
    let is_checked = $(this).is(":checked");
    let is_persisted = $(this).data("persisted");
    let submit_button = container.find("[type=submit]");
    container.find("[name=delete_object]").val(!is_checked);
    if (is_checked) {
      submit_button.val("SAVE");
      submit_button.attr("data-disable-with", "SAVING...");
      submit_button.removeClass("hide");
    } else {
      if (is_persisted) {
        submit_button.val("DELETE");
        submit_button.attr("data-disable-with", "DELETING...");
        submit_button.removeClass("hide");
      } else {
        submit_button.addClass("hide");
      }
    }
  });

  $(".editable-tour-details").focusout(function () {
    var id = $(this).attr("id");
    var value = $(this).val();
    $.ajax({
      method: "POST",
      url: "/location_changes/" + id + "/update_notes",
      data: {
        notes: value,
      },
      beforeSend: function () {
        $("body").css("cursor", "progress");
      },
      success: function (response) {
        $("body").css("cursor", "default");
      },
    });
  });

  $("#exclude").selectize({
    multiple: true,
  });

  $("#tours").selectize({
    multiple: true,
  });

  $("#routes").selectize({
    multiple: true,
    render: {
      option: function (item, escape) {
        var result = item.text.split("|||");
        var label = result[0];
        var color = result[1];
        return (
          '<div style="background-color: ' +
          color +
          '">' +
          escape(label) +
          "</div>"
        );
      },
    },
  });

  var start_date_element = $("#start_date");
  var end_date_element = $("#end_date");
  var selected_year = start_date_element.data("selected-year");
  var min_date = undefined;
  var max_date = undefined;

  if (selected_year) {
    min_date = new Date(selected_year, 0, 1);
    max_date = new Date(min_date.getFullYear(), 11, 31);
  }

  start_date_element.datepicker({
    showOn: "focus",
    showButtonPanel: true,
    dateFormat: "yy-mm-dd",
    closeText: "Clear", // Text to show for "close" button
    minDate: min_date,
    maxDate: max_date,
    onClose: function () {
      var event = arguments.callee.caller.caller.arguments[0];
      // If "Clear" gets clicked, then really clear it
      if ($(event.delegateTarget).hasClass("ui-datepicker-close")) {
        $(this).val("");
      }
    },
    onSelect: function (date) {
      var selectedDate = new Date(date);

      end_date_element.datepicker("option", "minDate", selectedDate);
      if (!selected_year)
        end_date_element.datepicker("option", "maxDate", "+2y");

      $(this).trigger("change");
    },
  });

  end_date_element.datepicker({
    showOn: "focus",
    showButtonPanel: true,
    dateFormat: "yy-mm-dd",
    closeText: "Clear", // Text to show for "close" button
    minDate: min_date,
    maxDate: max_date,
    onClose: function () {
      var event = arguments.callee.caller.caller.arguments[0];
      // If "Clear" gets clicked, then really clear it
      if ($(event.delegateTarget).hasClass("ui-datepicker-close")) {
        $(this).val("");
      }
    },
  });

  $("select.global-select[data-param], input[data-param]").change(function () {
    Cookies.set($(this).data("param"), $(this).val(), { expires: 365 });
    window.location.reload(true);
  });

  var import_table_filters = $(".color-sample.filter[data-status]");

  import_table_filters.click(function () {
    $(this).toggleClass("inactive");

    if ($(this).hasClass("inactive")) {
      var active_statuses = import_table_filters
        .filter(":not(.inactive)")
        .map(function (i, elem) {
          return $(elem).data("status");
        });
      rows = $("table tbody td." + $(this).data("status")).closest("tr");
      active_statuses.each(function (i, status) {
        rows = rows.filter(":not(:has(." + status + "))");
      });
      rows.hide();
    } else {
      $("table tbody td." + $(this).data("status"))
        .closest("tr")
        .show();
    }
  });

  $(".import-item-checkbox[data-id]").change(function () {
    $.ajax({
      url: "/imports/items/" + $(this).data("id"),
      type: "PATCH",
      data: {
        import_item: {
          is_selected: $(this).prop("checked"),
        },
      },
    });
  });

  var loc_id = $("#location_id").val();
  var dropzone_container = $("#drop-zone");
  if (dropzone_container.length > 0) {
    var url = "/locations/upload_attachment";
    if (loc_id != "") {
      url = "/locations/" + loc_id + "/upload_attachment";
    }
    var myDropzone = new Dropzone("div#drop-zone", {
      url: url,
      acceptedFiles: "image/*,application/pdf, .heif, .heic",
      success: function (file, response) {
        var new_item = $(response.field).hide();
        $("#location_attachments").append(new_item);
        new_item.show("normal");
      },
    });
    Dropzone.options.myDropzone = {
      paramName: "file", // The name that will be used to transfer the file
    };
  }

  // var dropzone_container = $("#drop-zone_0")
  // if(dropzone_container.length > 0){
  //   var url = "/locations/upload_attachment"
  //   if(loc_id != ""){
  //     url = "/locations/"+loc_id+"/upload_attachment"
  //   }
  //   var myDropzones = new Dropzone("div#drop-zone_0", {
  //     url: url,
  //     success: function (file, response) {
  //         var new_item = $(response.field).hide();
  //         $("#location_attachments").append(new_item)
  //         new_item.show('normal');
  //     },
  //   });
  //   Dropzone.options.myDropzones = {
  //     paramName: "file", // The name that will be used to transfer the file
  //   };
  // }
  if(body_id != "refunded_orders-new"){
    $(document).foundation();
    $(".no-accordion-link").off(".zf.accordion");
    jQuery("aside .inner").scrollbar();

    PT.init.TourNewEdit();
    PT.init.TourMapSearch();
    PT.init.RegionMarket();
    PT.init.Products();
    PT.init.InitializeSelectize();
    PT.init.CanceledOrders();
    PT.init.MigratedOrders();
    PT.init.CustomerNotifications();
    PT.init.MenuChange();
    PT.init.RouteNewEdit();
    PT.init.DraftOrders();
    PT.init.Tours();
    PT.init.StockActions();
    PT.init.Dashboard();
    PT.init.ColorPicker();
    PT.init.CustomSelect();
  }
});

window.PT = {};
window.location_selection;
window.stop_selection;

PT.init = $.extend({
  MenuChange: function () {
    if (x.matches && Cookies.get("mini_menu") == "true") {
      var slides = document.getElementsByClassName("is-accordion-submenu");
      for (var i = 0; i < slides.length; i++) {
        slides[i].style.display = "none";
      }
    }
  },
  FoundationGeneral: function () {
    // Remove empty P tags created by WP inside of Accordion and Orbit
    $(".accordion p:empty, .orbit p:empty").remove();

    // Adds Flex Video to YouTube and Vimeo Embeds
    $('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function () {
      if ($(this).innerWidth() / $(this).innerHeight() > 1.5) {
        $(this).wrap("<div class='widescreen responsive-embed'/>");
      } else {
        $(this).wrap("<div class='responsive-embed'/>");
      }
    });
  },
  TourNewEdit: function () {
    var current_status = $(".tour-status-select select").val();

    if ($("#tour-dates-repeater").length > 0) {
      $("#tour-dates-repeater").createRepeater({
        showFirstItemToDefault: true,
        addButtonCallback: function () {
          $(".stop, .repeat_until_date").datepicker({ dateFormat: "mm/dd/yy" });
          $(".tour_start_time").timepicker({ timeFormat: "hh:mm TT" });
          $(".tour_end_time").timepicker({ timeFormat: "hh:mm TT" });
          dateTypeSelect();
        },
      });

      $(".stop, .repeat_until_date").datepicker({ dateFormat: "mm/dd/yy" });
      $(".tour_start_time").timepicker({ timeFormat: "hh:mm TT" });
      $(".tour_end_time").timepicker({ timeFormat: "hh:mm TT" });
      dateTypeSelect();
    }
    $("#tour_name").focus();

    $(".edit-status").on("click", (e) => {
      e.preventDefault();
      var _this = e.currentTarget;
      $(_this).hide();
      $(".tour-status-select").show();
    });

    $(".cancel-status").on("click", (e) => {
      e.preventDefault();
      var _this = e.currentTarget;
      $(".edit-status").show();
      $(".tour-status-select").slideUp();
      $(".tour-status-select select").val(current_status);
    });

    $(".ok-status").on("click", (e) => {
      e.preventDefault();
      var _this = e.currentTarget;
      var status_name = "";
      if ($(".tour-status-select select")[1].value == "false") {
        status_name = "Inactive";
      } else {
        status_name = "Active";
      }
      $(".status-name").html(status_name);
      $(".edit-status").show();
      $(".tour-status-select").slideUp();
      current_status = $(".tour-status-select select").val();
    });

    $(".tour_region_selection").on("change", (e) => {
      if ($(".tour_region_selection option:selected").val() != "") {
        $.ajax({
          url: "/locations/get_markets",
          type: "GET",
          dataType: "script",
          data: {
            market_id: $(".tour_region_selection option:selected").val(),
          },
        });
      } else {
        $(".tour_market_selection").empty();
        $(".tour_market_selection").append(
          $("<option>Select Region First</option>")
        );
      }
    });

    function dateTypeSelect() {
      // Date type select

      $(".repeater-items .items").each(function (i, v) {
        var item = $(v);

        item.find(".date_type_select").on("change", function () {
          if ($(this).val() == "weekly") {
            item.find(".repeat_until_wrapper").removeClass("hide");
          } else {
            item.find(".repeat_until_wrapper").addClass("hide");
            item.find(".repeat_until_date").val("");
          }
        });

        if (item.find(".date_type_select").val() == "weekly") {
          item.find(".repeat_until_wrapper").removeClass("hide");
        }
      });
    }

    dateTypeSelect();
  },
  RouteNewEdit: function () {
    var current_status = $(".tour-status-select select").val();

    if ($("#route-dates-repeater").length > 0) {
      $("#route-dates-repeater.require-init").createRepeater({
        showFirstItemToDefault: true,
        addButtonCallback: function (t, item) {
          $(".route_date").datepicker({
            dateFormat: "yy-mm-dd",
            onSelect: function (date) {
              let selected_index = $(this).closest(".items").data("index");
              $.ajax({
                url: "/routes/route_dates",
                type: "GET",
                data: {
                  selected_index: selected_index,
                  selected_date: date,
                  date_changed: true,
                },
              });
            },
          });

          $(".items:last-child").find(".details").remove();
        },
      });

      $("#route-dates-repeater").removeClass("require-init");

      if (!$("#route-dates-repeater").hasClass("require-init")) {
        $(".route_date").datepicker({
          dateFormat: "yy-mm-dd",
          onSelect: function (date) {
            let selected_index = $(this).closest(".items").data("index");
            $.ajax({
              url: "/routes/route_dates",
              type: "GET",
              data: {
                selected_index: selected_index,
                selected_date: date,
                date_changed: true,
              },
            });
          },
        });
      }
    }

    $(".route-stops").each(function (i, v) {
      var el = v;
      var sortable = Sortable.Sortable.create(el, {
        group: "route-sortable-stops",
        onClone: function (evt) {
          var origEl = evt.item;
          var cloneEl = evt.clone;

          // $grid.remove( origEl )

          $(origEl).removeAttr("style");
          $(cloneEl).removeAttr("style");
        },
        onEnd: function (evt) {
          if ($(evt.from).hasClass("from")) {
            $(evt.item).find(".destroy").val(false);
          } else {
            $(evt.item).find(".destroy").val(true);
          }
        },
        onSort: function (evt) {
          let route_date_index = $(evt.item).closest(".items").data("index");
          let route_date_stop_index = evt.newIndex;

          var lis = $(evt.to).find("li");

          lis.each(function (i, v) {
            if ($(evt.from).hasClass("from")) {
              $(v)
                .find(".destroy")
                .attr(
                  "name",
                  "route[route_dates_attributes][" +
                    route_date_index +
                    "][route_date_stops_attributes][" +
                    i +
                    "][_destroy]"
                );
              $(v)
                .find(".stop_id")
                .attr(
                  "name",
                  "route[route_dates_attributes][" +
                    route_date_index +
                    "][route_date_stops_attributes][" +
                    i +
                    "][stop_id]"
                );
            } else {
              $(v).find(".stop_id").attr("name", "");
            }
          });
        },
      });
    });

    $("#route_name").focus();
  },
  RegionMarket: function () {
    if ($("#markets-repeater").length > 0) {
      $("#markets-repeater").createRepeater({
        showFirstItemToDefault: true,
      });
    }

    if ($("#region-tours-repeater").length > 0) {
      $("#region-tours-repeater").createRepeater({
        showFirstItemToDefault: true,
        addButton: $(".repeater-addbtn-tour"),
      });
    }

    $(".sortable").each(function (i, v) {
      var el = v;

      var sortable = Sortable.Sortable.create(el, {
        group: "region-sortable",
        onSort: function (evt) {
          evt.newIndex;
          var lis = $(evt.to).find(" > li");
          var updated_order = [];
          lis.each(function (i, v) {
            var market = {
              id: $(v).data("id"),
              position: i,
              name: $(v).data("name"),
            };
            updated_order.push(market);
          });

          if (updated_order) {
            $.ajax({
              url: "/regions/sort_markets",
              type: "POST",
              dataType: "json",
              data: {
                region_id: $(evt.to).data("id"),
                market_orders: JSON.stringify(updated_order),
              },
              success: function (response) {
                if (response.success == false) {
                  window.location.href =
                    window.location.href.split("?")[0] +
                    "?message=" +
                    response.message;
                }
              },
            });
          }
        },
      });
    });

    // quick search regex
    if ($(".regions-tour-list").length) {
      var qsRegex;
      var isotope = require("isotope-layout");

      var $grid = new isotope(".regions-tour-list", {
        itemSelector: ".element-item",
        layoutMode: "fitRows",
        filter: function (itemElem) {
          return qsRegex
            ? $(itemElem).find(".search-by").text().match(qsRegex)
            : true;
        },
      });

      // use value of search field to filter
      var $quicksearch = $(".quicksearch").keyup(
        debounce(function () {
          qsRegex = new RegExp($quicksearch.val(), "gi");

          $grid.arrange({
            // item element provided as argument
            filter: function (itemElem) {
              return qsRegex
                ? $(itemElem).find(".search-by").text().match(qsRegex)
                : true;
            },
          });
        }, 200)
      );
    }

    // debounce so filtering doesn't happen every millisecond
    function debounce(fn, threshold) {
      var timeout;
      threshold = threshold || 100;
      return function debounced() {
        clearTimeout(timeout);
        var args = arguments;
        var _this = this;
        function delayed() {
          fn.apply(_this, args);
        }
        timeout = setTimeout(delayed, threshold);
      };
    }

    $(".sortable .market-tours, #regions-index .regions-tour-list").each(
      function (i, v) {
        var el = v;

        var sortable = Sortable.Sortable.create(el, {
          group: "region-sortable-tours",
          onClone: function (evt) {
            var origEl = evt.item;
            var cloneEl = evt.clone;

            $grid.remove(origEl);

            $(origEl).removeAttr("style");
            $(cloneEl).removeAttr("style");
          },
          onEnd: function (evt) {
            if ($(evt.from).hasClass("market-tours")) {
              // Comment out until fixed
              // var item = evt.item
              // $(evt.item).remove()
              // $(evt.item).addClass('element-item');
              // var $items = $(item.outerHTML)
              // var elems = [];
              // elems.push( $items[0] );
              // $grid.insert( elems )
            }
          },
          onSort: function (evt) {
            evt.newIndex;

            var lis = $(evt.to).find("li");
            var updated_order = [];
            var market_id = $(evt.to).closest("li").data("id");

            lis.each(function (i, v) {
              var market = {
                id: $(v).data("id"),
                position: i,
                name: $(v).data("name"),
              };
              updated_order.push(market);
            });

            if (updated_order) {
              $.ajax({
                url: "/regions/sort_locations",
                type: "POST",
                dataType: "json",
                data: {
                  market_id: market_id,
                  tour_orders: JSON.stringify(updated_order),
                },
                success: function (response) {
                  if (response.success == false) {
                    window.location.href =
                      window.location.href.split("?")[0] +
                      "?message=" +
                      response.message;
                  }
                },
              });
            }
          },
        });
      }
    );
  },
  TourMapSearch: function () {
    if (document.getElementById("google-map") != null) {
      const LAT = Number($("#location_lat").val()) || 36.1626638;
      const LNG = Number($("#location_lng").val()) || -86.7816016;

      const myLatlng = { lat: LAT, lng: LNG };

      const map = new google.maps.Map(document.getElementById("google-map"), {
        center: myLatlng,
        zoom: 13,
        mapTypeId: "roadmap",
      });

      const geocoder = new google.maps.Geocoder();
      // Create the search box and link it to the UI element.
      const input = document.getElementById("tour-search");
      const searchBox = new google.maps.places.SearchBox(input);

      map.addListener("bounds_changed", () => {
        searchBox.setBounds(map.getBounds());
      });

      var marker = new google.maps.Marker({
        draggable: true,
        position: myLatlng,
        map: map,
        title: "Tour location",
      });

      map.addListener("click", (event) => {
        marker.setPosition(event.latLng);
        map.setCenter(event.latLng);

        var lat = event.latLng.lat();
        var lng = event.latLng.lng();
        searchPosition(lat, lng);
      });

      var formatted_addresses = [];

      google.maps.event.addDomListener(input, "keypress", function (e) {
        if (e.key !== "Enter") return;

        value = $("#tour-search").val();

        var ex1 = new Event("keydown");
        ex1.code = "ArrowDown";
        ex1.key = "ArrowDown";
        ex1.keyCode = 40;
        google.maps.event.trigger(this, "keydown", ex1);

        var ex2 = new Event("keydown");
        ex2.code = "Enter";
        ex2.key = "Enter";
        ex2.keyCode = 13;
        google.maps.event.trigger(this, "keydown", ex2);

        $("#tour-search").val(value);

        e.preventDefault();
      });

      function check_address() {
        let warning = $(".formatted-address-warning");
        let value = $("#tour-search").val();

        if (value != "" && formatted_addresses.includes(value)) warning.hide();
        else warning.show();
      }

      $("#tour-search").change(check_address);

      let markers = [];
      searchBox.addListener("places_changed", () => {
        const places = searchBox.getPlaces();

        if (places.length == 0) {
          return;
        }

        const bounds = new google.maps.LatLngBounds();

        formatted_addresses = $.map(
          places.filter((place) => place.geometry),
          (place) => place.formatted_address
        );
        check_address();

        places.forEach((place) => {
          if (!place.geometry) {
            console.log("Returned place contains no geometry");
            return;
          }

          if (place.geometry.viewport) {
            // Only geocodes have viewport.
            bounds.union(place.geometry.viewport);
          } else {
            bounds.extend(place.geometry.location);
          }

          map.fitBounds(bounds);
          marker.setPosition(place.geometry.location);

          LatLngFieldPopulate(
            place.geometry.location.lat(),
            place.geometry.location.lng()
          );
        });
      });

      function searchPosition(lat, lng) {
        var latLng = { lat: lat, lng: lng };
        geocoder.geocode(
          { location: latLng },
          function (results, status) {
            if (status !== "OK") {
              alert("Location Not Found");
            } else {
              $("#tour-search").val(results[0].formatted_address);
              LatLngFieldPopulate(lat, lng);
            }
          }.bind(this)
        );
      }

      function LatLngFieldPopulate(lat, lng) {
        $("#location_lat").val(lat);
        $("#location_lng").val(lng);
      }
    }
  },
  InitializeSelectize: function () {
    $("select.selectize:not(.selectized)").each(function (index, element) {
      $(element).selectize({
        create: !!$(element).data("create"),
      });
    });

    window.location_selection = $(
      ".order_tour_selection:not([class*=selectize]), .to_order_tour_selection:not([class*=selectize])"
    ).selectize({
      create: false,
      sortField: "text",
      allowEmptyOption: true,
      delimiter: ",",
      onInitialize: function () {
        var item = $(this).find(".item").first();
        if (item.length) {
          var res = item.html();
          var first = res.split("|||")[0];
          item.html(first);
        }
      },
      onChange: function (value) {

        var _this = this;
        var stop_class;
        var input = _this.$input[0];
        if (input != undefined) {
          if ($(_this.$input[0]).hasClass("to_order_tour_selection")) {
            stop_class = ".to_order_stop_selection";
          }
          var data_stop_class = $(input).data("stop-class");
          if (data_stop_class) {
            stop_class = data_stop_class;
          }
        }
        var item = $(this).find(".item").first();
        var res = item.html();
        if (item.length) {
          var first = res.split("|||")[0];
          item.html(first);
        }
        disable_draft = input.classList.contains("disable_draft_stops");

        if (value != "") {
          $.ajax({
            url:
              "/locations/" + value + "/stops?disable_draft=" + disable_draft,
            data: {
              year: $(input).data("year"),
              stop_class: stop_class,
              include_all_option: $(input).data("include-all-option"),
            },
            type: "GET",
          });
        }
      },
      render: {
        option: function (item, escape) {
          if (item.text.indexOf("(INACTIVE)") !== -1) {
            color = "red";
            cursor = "not-allowed";
          } else {
            color = "black";
            cursor = "pointer";
          }
          if (item.value != "") {
            var result = item.text.split("|||");
            var dates = result[1].split(",");

            var label = result[0];
            var title = result[0].split("--")[0];
            var address = result[0].split("--")[1];
            var caption = result[1];
            var res = "";
            $.each(dates, function (k, v) {
              res =
                res +
                '<span style="display: block; color: gray; font-size: 12px; margin-left: 20px; cursor: ' +
                cursor +
                ';">' +
                escape(v) +
                "</span>";
            });
            return (
              "<div>" +
              '<span style="display: block; color: ' +
              color +
              "; cursor: " +
              cursor +
              '; font-size: 14px; margin-left: 5px;"><b>' +
              escape(title) +
              "</b> - " +
              escape(address) +
              status +
              "</span>" +
              res +
              "</div>"
            );
          } else {
            return (
              "<div>" +
              '<span style="display: block; color: black; font-size: 14px; margin-left: 5px; "></span></div>'
            );
          }
        },
      },
    });
  },
  CanceledOrders: function () {
    $("form.new_canceled_order .preview-changes").on("click", function (e) {
      e.preventDefault();
      let form = $(this).closest("form");
      let form_data_array = form.serializeArray();

      $.ajax({
        type: "POST",
        url: "/canceled_orders/preview_changes",
        data: form.serialize(), // serializes the form's elements.
        success: function (data) {
          let total_orders = data.total_orders;
          let total_boxes = data.total_boxes;
          let total = 0;
          let order_tr = "";

          if (data) {
            for (var i = data.orders.length - 1; i >= 0; i--) {
              let line_items = "";
              let order_total = 0;
              for (var k = data.orders[i].line_items.length - 1; k >= 0; k--) {
                total += Number(data.orders[i].line_items[k].price);
                order_total += Number(data.orders[i].line_items[k].price);
                line_items +=
                  data.orders[i].line_items[k].quantity +
                  "x" +
                  data.orders[i].line_items[k].title;
                if (k != 0) {
                  line_items += ", ";
                }
              }

              order_tr +=
                "<tr><td>" +
                data.orders[i].order_id +
                "</td><td>" +
                data.orders[i].order_number +
                "</td><td>" +
                line_items +
                "</td><td>$" +
                order_total +
                "</td></tr>";
            }
            $("#preview-cancel-orders-changes").removeClass("hide");

            $("#preview-cancel-orders-changes .total-orders").html(
              total_orders + " - "
            );
            $("#preview-cancel-orders-changes .total-boxes").html(
              total_boxes + " - "
            );
            $("#preview-cancel-orders-changes table tbody").html(order_tr);
            $("#preview-cancel-orders-changes .total").html("$" + total);
          }
        },
      });
    });
  },
  MigratedOrders: function () {
    $("form.new_migrated_order .preview-changes").on("click", function (e) {
      e.preventDefault();
      let form = $(this).closest("form");
      let form_data_array = form.serializeArray();

      $.ajax({
        type: "POST",
        url: "/migrated_orders/preview_changes",
        data: form.serialize(), // serializes the form's elements.
        success: function (data) {
          let total_orders = data.total_orders;
          let total_boxes = data.total_boxes;
          let order_tr = "";

          if (data) {
            for (var i = data.orders.length - 1; i >= 0; i--) {
              order_tr +=
                "<tr><td>" +
                data.orders[i].order_id +
                "</td><td>#" +
                data.orders[i].order_number +
                "</td><td>" +
                data.orders[i].customer.email +
                "</td></tr>";
            }
            $("#preview-migrate-orders-changes").removeClass("hide");

            $("#preview-migrate-orders-changes .total-orders").html(
              total_orders + " - "
            );
            $("#preview-migrate-orders-changes .total-boxes").html(total_boxes);

            $("#preview-migrate-orders-changes table tbody").html(order_tr);
          }
        },
      });
    });
  },
  CustomerNotifications: function () {
    $("form.new_customer_notification .preview-changes").on(
      "click",
      function (e) {
        e.preventDefault();
        let form = $(this).closest("form");
        let form_data_array = form.serializeArray();

        $.ajax({
          type: "POST",
          url: "/customer_notifications/preview_changes",
          data: form.serialize(), // serializes the form's elements.
          success: function (data) {
            let total_orders = data.total_orders;
            let total_boxes = data.total_boxes;
            let order_tr = "";

            if (data) {
              for (var i = data.orders.length - 1; i >= 0; i--) {
                order_tr +=
                  "<tr><td>" +
                  data.orders[i].order_id +
                  "</td><td>#" +
                  data.orders[i].order_number +
                  "</td><td>" +
                  data.orders[i].customer.email +
                  "</td></tr>";
              }
              $("#preview-customer-notifications-changes").removeClass("hide");

              $("#preview-customer-notifications-changes .total-orders").html(
                total_orders + " - "
              );
              $("#preview-customer-notifications-changes .total-boxes").html(
                total_boxes
              );

              $("#preview-customer-notifications-changes table tbody").html(
                order_tr
              );
            }
          },
        });
      }
    );
  },
  DraftOrders: function () {
    if (document.getElementById("draft-map-container") != null) {
      $(".draft_order_products_repeater").createRepeater({
        showFirstItemToDefault: true,
        addButtonCallback: function () {
          $(".items:last-child").find(".qty").val("1");
          variant_select = $(".items:last-child").find(
            "select[data-name=variant_id]"
          );
          if (typeof products_options_html !== "undefined")
            variant_select.html(products_options_html);
          variant_select.val("");
          $(".items:last-child").find(".product_price").text("0.00");
          $(".items:last-child").find(".product_total").text("0.00");
        },
      });

      $(document).on(
        "change",
        ".draft_order_products_repeater select, .draft_order_products_repeater .qty, .draft_order_products_repeater .remove-btn",
        function () {
          let variant_id = $(this).closest(".items").find("select").val();
          let quantity = $(this).closest(".items").find(".qty").val();
          let selected_index = $(this).closest(".items").data("index");
          if ($($(this).closest("form")[0]).hasClass("shopify_draft_order")) {
            path = "/app/line_items_details";
          } else {
            path = "/draft_orders/line_items_details";
          }

          $.ajax({
            url: path,
            type: "GET",
            data: {
              selected_index: selected_index,
              variant_id: variant_id,
              location_id: $("#draft_order_location_id").val(),
              quantity: quantity,
            },
          });
        }
      );

      var location_selector = window.location_selection[0].selectize;

      location_selector.on("change", function () {
        var val = this.items[0];

        if ($("form.shopify_draft_order").length) {
          path = "/app/location_products.js";
        } else {
          path = "/draft_orders/location_products.js";
        }

        $.ajax({
          url: path,
          type: "GET",
          data: {
            location_id: val,
          },
        });
      });

      $(".order_stop_selection").on("change", function () {
        var val = this.value;
        $(".tour_date_select input[value='" + val + "']").prop("checked", true);
      });

      function infoWindowOnReady(marker, infowindow) {
        google.maps.event.addListener(infowindow, "domready", function () {
          // selectLocation(marker);
          $(".map-infowindow")
            .find(".tour_date_select li:first-child input")
            .prop("checked", true);
        });

        $(document).on("change", ".tour_date_select input", function () {
          selectLocation(marker, true);
        });
      }

      function selectLocation(marker, stop_select = false) {
        var location_id = $(".map-infowindow").data("id");
        var stop_id = $('.map-infowindow input[type="radio"]:checked').val();
        if (stop_select) {
          $(".order_stop_selection").val(stop_id);
        } else {
          location_selector.setValue(marker.location_id);
        }
      }
    }
  },
  Tours: function () {
    $(".tour_date").datepicker({
      dateFormat: "mm/dd/yy",
    });
  },
  StockActions: function () {
    let stock_resources_selects = $("select.stock-resources");
    let transfer_amount_selects = $("input[data-transfer-amount]");

    stock_resources_selects.selectize({
      valueField: "id",
      labelField: "name",
      searchField: "name",
      options: [],
      persist: false,
      loadThrottle: 600,
      create: false,
      allowEmptyOption: true,
      render: {
        option: function (data, escape) {
          return (
            "<div data-resource-type='" +
            escape(data.resource_type) +
            "'>" +
            escape(data.name) +
            "</div>"
          );
        },
      },
      load: function (query, callback) {
        if (!query.length) return callback();
        $.ajax({
          url: "/stock_actions/search.json",
          type: "GET",
          dataType: "json",
          data: {
            name: query,
          },
          error: function () {
            callback();
          },
          success: function (res) {
            resources_data = resources_data.concat(res);
            callback(res);
          },
        });
      },
    });

    function update_stock_variables(element) {
      let resource_id = $(element).val();
      if (!resource_id) return;

      let data = $(element).data("selectize").options[$(element).val()];
      let resource_type = data["resource-type"];

      $.ajax({
        url: "/stock_actions/get_stock.json",
        type: "GET",
        dataType: "json",
        data: { resource_id, resource_type },
        success: function (res) {
          stocks = {
            ...stocks,
            ...res,
          };
          precalculate_stocks(element);
        },
      });
    }

    function get_stock(resource_id_input, stock_preview_input) {
      let resource_type_input = $(
        resource_id_input.data("type-input-selector")
      ).first();
      return (
        stocks[
          resource_type_input.val() +
            "_" +
            resource_id_input.val() +
            "_" +
            stock_preview_input.data("product-type")
        ] || 0
      );
    }

    function precalculate_stocks(element) {
      let form = $(element).closest("form");
      form.find("input[data-stock]").each(function (index, input) {
        let transfer_amount_select = $(
          "input[data-transfer-amount][data-product-type=" +
            $(input).data("product-type") +
            "]"
        );
        let transfer_amount = parseInt(transfer_amount_select.val()) || 0;
        let value;
        if ($(input).data("source")) {
          value =
            get_stock($("#stock_action_source_id"), $(input)) - transfer_amount;
        } else if ($(input).data("target")) {
          value =
            get_stock($("#stock_action_target_id"), $(input)) + transfer_amount;
        } else {
          value = get_stock($(element), $(input));
        }
        $(input).val(value);
      });
    }

    stock_resources_selects.change(function () {
      let type_element = $($(this).data("type-input-selector")).first();
      if (!type_element.length) return;

      let data = $(this).data("selectize").options[$(this).val()];
      if (!data) return;

      let resource_type = data["resource-type"];

      type_element.val(resource_type);
    });

    $(
      "#resource_select, #stock_action_source_id, #stock_action_target_id"
    ).change(function () {
      update_stock_variables(this);
    });

    transfer_amount_selects.change(function () {
      precalculate_stocks(this);
    });
  },
  Dashboard: function () {
    function open_dashboard_section(hashtag) {
      $(".dashboard-section-button").removeClass("active");
      $(".dashboard-section-button[href='#" + hashtag + "']").addClass(
        "active"
      );
      $(".dashboard-section").hide();
      $(".dashboard-section[data-hashtag=" + hashtag + "]").show();
    }

    open_dashboard_section(window.location.href.split("#")[1] || "tour");

    $(".dashboard-section-button").click(function () {
      open_dashboard_section(this.href.split("#")[1]);
    });
  },
  Products: function () {
    $(".product-category-buttons .button").click(function () {
      $(this)
        .closest(".product-category-buttons")
        .find(".button.active")
        .removeClass("active");
      $(this).addClass("active");
      $(".tour-tag-form").hide();
      if ($(this).data("category")) {
        $(
          ".tour-tag-form[data-category-" + $(this).data("category") + "]"
        ).show();
        $(".products-table tbody tr").hide();
        $(
          ".products-table tbody tr[data-category-" +
            $(this).data("category") +
            "]"
        ).show();
      } else {
        $(".tour-tag-form[data-category-fruits]").show();
        $(".products-table tbody tr").show();
      }
    });

    $("#variants_repeater").createRepeater({
      addButtonCallback: function (t, item) {
        PT.init.InitializeSelectize();
      },
    });

    $(".product_type_repeater").each((index, repeater) =>
      $(repeater).createRepeater({
        addButtonCallback: function (t, item) {
          PT.init.InitializeSelectize();
        },
      })
    );
  },
  ColorPicker: function () {
    let color_input = $("#color-input");
    if (color_input.length > 0) {
      const pickr = Pickr.create({
        el: ".color-picker",
        theme: "classic", // or 'monolith', or 'nano'
        default: color_input.val(),
        components: {
          // Main components
          preview: true,
          opacity: false,
          hue: true,

          // Input / output Options
          interaction: {
            hex: true,
            rgba: false,
            hsla: false,
            hsva: false,
            cmyk: false,
            input: true,
            clear: true,
            save: true,
          },
        },
      });

      pickr.on("save", (color, _instance) => {
        color_input.val(color.toHEXA().toString());
        pickr.hide();
      });
    }
  },
  CustomSelect: function () {
    $("select.custom-select").each(function () {
      var $this = $(this),
        numberOfOptions = $(this).children("option").length;

      $this.addClass("select-hidden");
      $this.wrap('<div class="select custom-select"></div>');
      $this.after('<div class="select-styled"></div>');

      var $styledSelect = $this.next("div.select-styled");
      $styledSelect.text($this.children("option").eq(0).text());

      var $list = $("<ul />", {
        class: "select-options",
      }).insertAfter($styledSelect);

      for (var i = 0; i < numberOfOptions; i++) {
        $("<li />", {
          text: $this.children("option").eq(i).text(),
          rel: $this.children("option").eq(i).val(),
        }).appendTo($list);
      }

      var $listItems = $list.children("li");

      $styledSelect.click(function (e) {
        e.stopPropagation();
        $("div.select-styled.active")
          .not(this)
          .each(function () {
            $(this).removeClass("active").next("ul.select-options").hide();
          });
        $(this).toggleClass("active").next("ul.select-options").toggle();
      });

      $listItems.click(function (e) {
        e.stopPropagation();
        $styledSelect.text($(this).text()).removeClass("active");
        $this.val($(this).attr("rel"));
        $list.hide();
      });

      $(document).click(function () {
        $styledSelect.removeClass("active");
        $list.hide();
      });
    });
  },

});

PT.init.FoundationGeneral();

removeElement = (element) => {
  var parent_element = $(element).closest(".items");
  var destroy_element = parent_element.find('[data-name="_destroy"]').val(true);
  parent_element.hide();
  parent_element.prev().find(".qty").trigger("change");
  // if($(element).closest('#tour-dates-repeater').length > 0) {
  // parent_element.siblings().last().css('padding-bottom', '100px');
  // }
};

htmlDecode = (value) => {
  return $("<div/>").html(value).text();
};

post_selected_orders = () => {
  if (!Array.prototype.remove) {
    Array.prototype.remove = function (val, all) {
      var i,
        removedItems = [];
      if (all) {
        for (i = this.length; i--; ) {
          if (this[i] === val) removedItems.push(this.splice(i, 1));
        }
      } else {
        i = this.indexOf(val);
        if (i > -1) removedItems = this.splice(i, 1);
      }
      return removedItems;
    };
  }
  if (Cookies.get("order_ids") === undefined) {
    Cookies.set("order_ids", "");
  }
  if (Cookies.get("order_ids") == "") {
    var orders = [];
  } else {
    var orders = Cookies.get("order_ids").split(",");
  }
  $("#only_checked").val(false);
  $("#notification-selected").html(
    "<a href='' id='show_only_selected'><b>" +
      orders.length +
      " selected</b></a>"
  );
  $(".selected_order").on("change", function () {
    if ($(this).is(":checked")) {
      var order_id = $(this).val();
      orders.push(order_id);
    } else {
      var order_id = $(this).val();
      orders.remove(order_id);
    }
    orders = orders.filter(function (item, i, orders) {
      return i == orders.indexOf(item);
    });
    Cookies.set("order_ids", orders.join());
    $("#notification-selected").html(
      "<a href='' id='show_only_selected'><b>" +
        orders.length +
        " selected</b></a>"
    );
  });

  $("#show_only_selected").on("click", function (event) {
    event.preventDefault();
    $("#only_checked").val(true);
    $("#filter_submit").trigger("click");
  });
  $(".order_list input").each(function (index, element) {
    if ($.inArray($(element).val(), orders) >= 0) {
      $(element).prop("checked", true);
    }
  });

  $("#create_custom_notification").on("click", function () {
    if (orders.length == 0) {
      alert("Please select some orders!");
      return false;
    }
  });
};

$(document).on("click", ".toggle-hide", function () {
  console.log("aici");
  let { closest, selector, showText, hideText } = $(this).data();
  let element = $(this).closest(closest).find(selector);
  const svg = $(this).find(".expand svg");
  console.log(svg);
  element.slideToggle();
  element.toggleClass("hidden");
  if (element.hasClass("hidden")) {
    svg.removeClass("active");
  } else {
    svg.addClass("active");
  }
});
function repeaterItemsChange(repeater) {
  let visible_items = repeater.find(
    ".repeater-items-container > .repeater-item:visible"
  );
  visible_items.each(function (index, item_element) {
    let item = $(item_element);
    item.find("[data-name]").each(function (_index, input_element) {
      let input = $(input_element);
      input.attr("name", input.attr("data-name").replace("{index}", index));
      input.attr("id", input.attr("data-id").replace("{index}", index));
      input.removeClass("hasDatepicker");
    });
  });
  let remove_btn = repeater.find(
    ".repeater-items-container > .repeater-item .repeater-remove"
  );
  if (visible_items.length <= 1) {
    remove_btn.prop("disabled", true);
    remove_btn.addClass("disabled");
  } else {
    remove_btn.prop("disabled", false);
    remove_btn.removeClass("disabled");
  }
  setStartEndPicker();
}

$(document).on("click", ".simple-repeater .repeater-add", function () {
  let repeater = $(this).closest(".simple-repeater");
  let new_item = $(repeater.data("sample-item"));
  repeater.find(".repeater-items-container").append(new_item);
  $(new_item).find(".stop_id").val("");
  PT.init.InitializeSelectize();
  repeaterItemsChange(repeater);
});

$(document).on(
  "click",
  ".simple-repeater .repeater-items-container > .repeater-item .repeater-remove",
  function () {
    let repeater = $(this).closest(".simple-repeater");
    let item = $(this).closest(".repeater-item");
    removed_item = $(item).find("[data-old-name='[stops][{index}][stops_id]'");
    if (removed_item.val()) {
      $(item)
        .find("[data-old-name='[stops][{index}][stop_id_destroy]'")
        .val(true);
      $(item).css("display", "none");
    } else {
      item.remove();
    }
    repeaterItemsChange(repeater);
  }
);

initializeSimpleRepeater = function () {
  $(".simple-repeater:not(.inititalized)").each(function (
    index,
    repeater_element
  ) {
    let repeater = $(repeater_element);
    let sample_item = $(repeater.data("sample-item"));
    if (!sample_item.length) {
      let item = repeater
        .find(".repeater-items-container > .repeater-item")
        .first();
      sample_item = item.clone();
    }
    sample_item.removeClass("hasDatepicker");
    repeater.addClass("inititalized");
    if (!repeater.data("sample-item")) {
      repeater.data("sample-item", sample_item[0].outerHTML);
    }
    repeaterItemsChange(repeater);
  });
};

function setStartEndPicker() {
  $(".tour_start_time").timepicker({ timeFormat: "hh:mm TT" });
  $(".tour_end_time").timepicker({ timeFormat: "hh:mm TT" });
}

$(document).ready(initializeSimpleRepeater);

$(document).on("turbolinks:load", function () {
  let productIndex = $(".location-product-item:not(.template)").length;

  $("#add_location_product").off("click").on("click", function(e) {
    e.preventDefault();
    const template = $(".location-product-item.template");
    if (!template.length) {
      return;
    }

    const newItem = template.clone();
    newItem.removeClass("template");
    newItem.show();

    // Replace NEW_INDEX with actual index
    newItem.html(newItem.html().replace(/NEW_INDEX/g, productIndex));
    newItem.attr("data-index", productIndex);

    $("#location_products_container").append(newItem);
    productIndex++;
  });

  $(document).on("click", ".remove-location-product", function(e) {
    e.preventDefault();
    const item = $(this).closest(".location-product-item");
    item.find(".location-product-destroy").val("true");
    item.hide();
  });
});

$(document).on("click", "[data-toggle-element]", function (e) {
  let elements = $($(e.currentTarget).attr("data-toggle-element"));

  elements.toggle();
});
